const initPage = () => {
  const removeSpinner = () => {
    const pdfSpinnerContainer = document.querySelector('.pdf-spinner-container');
    if (pdfSpinnerContainer) {
      pdfSpinnerContainer.remove();
    }
  };

  const pdfCanvasContainer = document.getElementById('canvas-container');
  if (!pdfCanvasContainer) {
    removeSpinner();
    return;
  }

  const isPdfUrl = (url) => {
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.pathname.endsWith('.pdf');
    } catch {
      return false;
    }
  };

  const pdfUrl = pdfCanvasContainer.dataset.url;

  if (!pdfUrl || !isPdfUrl(pdfUrl)) {
    removeSpinner();
    console.error('Invalid or missing PDF URL');
    return;
  }

  const { pdfjsLib } = globalThis;
  pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://mozilla.github.io/pdf.js/build/pdf.worker.mjs';
  pdfjsLib.disableWorker = false;
  pdfjsLib.cMapOptions = {isEvalSupported: false};

  const loadPdfDocument = async (url) => {
    try {
      const pdf = await pdfjsLib.getDocument({
        url,
        disableAutoFetch: true,
        disableCreateObjectURL: true,
        isEvalSupported: false,
        // // Ensure JavaScript is not executed
        disableStream: true,
        enableXfa: false,  // XFA is related to forms but can be lumped in with these settings for robustness
      }).promise;

      await renderPdfPages(pdf);
    } catch (error) {
      console.error('Error loading PDF:', error);
    }

    removeSpinner();
  };

  const renderPdfPages = async (pdf) => {
    for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
      try {
        const page = await pdf.getPage(pageNumber);

        const scale = 2;
        const viewport = page.getViewport({ scale });

        const canvas = document.createElement('canvas');
        canvas.className = 'pdf-page-canvas';
        pdfCanvasContainer.appendChild(canvas);

        const context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        await page.render({
          canvasContext: context,
          viewport
        }).promise;
      } catch (error) {
        console.error(`Error rendering page ${pageNumber}:`, error);
      }
    }
    document.querySelector('.view-resume-actions').style.display = 'block';
  };

  loadPdfDocument(pdfUrl);

  const resumeContainer = document.querySelector('.pdf-viewer-container');
  if (resumeContainer) {
    const viewMoreBtn = resumeContainer.querySelector('.view-more-btn');
    const viewLessBtn = resumeContainer.querySelector('.view-less-btn');

    viewMoreBtn.addEventListener('click', () => resumeContainer.classList.add('show-more'));
    viewLessBtn.addEventListener('click', () => resumeContainer.classList.remove('show-more'));
  }
};

document.addEventListener('DOMContentLoaded', initPage);

export default initPage;
